module.exports = {
    apiKey: "AIzaSyA5PUevNxBASuC72_IqHMqpC8nGmbCv3GQ",
    authDomain: "balus-app.firebaseapp.com",
    databaseURL: "https://balus-app.firebaseio.com",
    projectId: "balus-app",
    storageBucket: "balus-app.appspot.com",
    messagingSenderId: "777108987504"
};


// WEBPACK FOOTER //
// ../etc/config/firebase/production.js